module.exports = __webpack_public_path__ + "static/img/GH.b1d48636.png";